import React from 'react';

import BottomSlider from '../BottomSlider/BottomSlider';

const ModuleBannerCarousel = ({
  slides,
  primaryColor,
  uiVariantBannerCarousel,
}) => {
  return (
    <div className="container">
      <BottomSlider
        slides={slides}
        primaryColor={primaryColor}
        uiVariantBannerCarousel={uiVariantBannerCarousel}
      />
    </div>
  );
};

export default ModuleBannerCarousel;
